import CustomLocalizationType from '../models/enums/custom-localization-type';
import { useAppSelector } from '../store';
import { selectCustomLocalizations } from '../store/general/general-slice-selectors';
import { useTranslation } from 'react-i18next';

const useCustomLocalizationEffect = () => {
  const { t } = useTranslation();

  const customLocalizationsData = useAppSelector((state) => selectCustomLocalizations(state));

  const localize = (value: string | null, type: CustomLocalizationType, description?: boolean) => {
    const localizationItem = customLocalizationsData.data?.find(
      (l) => type === l.type && l.codes.some((code) => code.code === value),
    );
    let localizationKey: string | undefined | null;
    if (description) {
      localizationKey = localizationItem?.descriptionKey;
    } else {
      localizationKey = localizationItem?.titleKey;
    }
    if (localizationKey != null) {
      return t(localizationKey);
    }
    if (description && localizationKey == null) {
      return null;
    }
    return value;
  };

  return localize;
};

export default useCustomLocalizationEffect;
